// extracted by mini-css-extract-plugin
export default {"underlineLink":"links_underlineLink__2yMGD"};